import { ref, computed } from "vue"

/**
 *
 * @param {object} data - data of control sush as label
 * @returns
 */
export const useQuantityControl = function (data, defaultQty = 0, minQty = 0, maxQty = 99) {
    const qty = ref(defaultQty)

    const methods = {
        increase: function () {
            if (canIncrease.value) {
                qty.value++
            }
        },
        decrease: function () {
            if (canDecrease.value) {
                qty.value--
            }
        }
    }

    const canIncrease = computed(() => {
        if (qty.value == maxQty) {
            return false
        }
        return true
    })
    const canDecrease = computed(() => {
        if (qty.value == minQty) {
            return false
        }
        return true
    })

    const getParams = function () {

    }


    return {
        qty,
        item: data,
        canIncrease,
        canDecrease,
        methods,
        getParams,
        minQty,
        maxQty
    }
}

// using useQuantityControl
export const useQuantityControlGroup = function (items) {
    const controllers = []
    const values = ref([])

    for (const item of items) {
        const controller = useQuantityControl(item, 0, 0, 9)
        controllers.push(controller)
        values.value.push({ data: item, qty: 0 })
    }

    const getParams = function () {

    }

    return {
        values,
        controllers,
        getParams
    }
}

export default { useQuantityControl, useQuantityControlGroup }
